import { FILTER_TYPE_TO_NAME_MAPPING } from 'apps//catalogue/models/FilterType';

export default function prepareFilterValues(filters) {
  return filters
    .map(
      filter => `${FILTER_TYPE_TO_NAME_MAPPING[filter.filterType]}:${filter.name}`
    )
    .join('|');
}
